import { Container, Sprite } from 'pixi.js';
import { getTexture } from '@/assets/resolver';
import { weaponGlyphKey } from '@/config/weapon-visuals';

/** Seconds a weapon glyph takes to fly bag ⇄ socket */
const FLY_TIME = 0.32;
/** Arc height of the flight (design px) */
const FLY_LIFT = 46;

interface Flight {
  sprite: Sprite;
  fx: number;
  fy: number;
  tx: number;
  ty: number;
  t: number;
}

/**
 * Equip feedback (docs/09 wave 4): the weapon's glyph visibly flies from the
 * bag into its socket (and a swapped-out one flies back). Persistent
 * overlay like ShopGains — the bay's rebuild never clears it.
 */
export class ShopFly {
  readonly view = new Container();
  private flights: Flight[] = [];

  launch(weaponId: string, from: { x: number; y: number }, to: { x: number; y: number }): void {
    const sprite = new Sprite(getTexture(weaponGlyphKey(weaponId)));
    sprite.anchor.set(0.5);
    sprite.position.set(from.x, from.y);
    this.view.addChild(sprite);
    this.flights.push({ sprite, fx: from.x, fy: from.y, tx: to.x, ty: to.y, t: 0 });
  }

  tick(dt: number): void {
    for (const f of this.flights) {
      f.t += dt;
      const p = Math.min(1, f.t / FLY_TIME);
      const e = 1 - (1 - p) * (1 - p); // ease-out
      f.sprite.position.set(
        f.fx + (f.tx - f.fx) * e,
        f.fy + (f.ty - f.fy) * e - Math.sin(Math.PI * p) * FLY_LIFT,
      );
      f.sprite.scale.set(0.8 + 0.5 * Math.sin(Math.PI * p));
      f.sprite.alpha = p < 0.85 ? 1 : (1 - p) / 0.15;
    }
    const done = this.flights.filter((f) => f.t >= FLY_TIME);
    if (done.length === 0) return;
    for (const f of done) f.sprite.destroy();
    this.flights = this.flights.filter((f) => f.t < FLY_TIME);
  }
}
